import type { NextPage } from 'next';
import Error from 'next/error';

import { Button } from '@components/Atoms';
import { ButtonType } from '@components/Atoms/Button/types';

import { globalContentController, pageController } from '@controllers/index';
import { rowFactory } from '@factories/index';

import { PageType } from '@lib/types';
import { getSlug, makeSrc, renderComponents } from '@lib/utils';

import { logger } from '@lib/logger';

const root = process.env.NEXT_PUBLIC_CMS_MEDIA_ROOT_URL;

export const getServerSideProps = async ({ resolvedUrl }) => {
  const slug = getSlug({ type: PageType.LEGAL_PAGE, resolvedUrl });

  let page: any = {};
  let pages: any = [];
  let footerData: any = [];
  let registerInterestData: any = [];

  try {
    page = await pageController.getLegalPageBySlug({ slug });
    pages = await pageController.getPages();
    footerData = await globalContentController.getFooter();
    registerInterestData = await globalContentController.getRegisterInterestData();
  } catch (err) {
    logger.error(err);
  }

  const headerData = pageController.getHeaderData({ page: null, pages });

  return {
    props: {
      headerData,
      footerData,
      registerInterestData,
      layoutProps: { headerInverted: false, gradientBackground: true },
      data: {
        page,
      },
    },
  };
};

const Page: NextPage = ({ headerData, data }: any) => {
  if (!headerData || !data.page) {
    return <Error statusCode={404} />;
  }

  const src = makeSrc({ url: data.page?.legalFile?.url || '#', root });

  const Hero = rowFactory.createRow({
    type: 'hero',
    attributes: data.page.Hero,
  });

  const PDF = (
    <section className="container mx-auto flex justify-center pb-36">
      <Button buttonType={ButtonType.PRIMARY}>
        <a href={src} target="_blank" rel="noreferrer">
          Download PDF
        </a>
      </Button>
    </section>
  );

  return renderComponents({ components: [Hero, PDF] });
};

export default Page;
